import Base from './base'
import urls from 'config/urls'

class Resource extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.resource.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.resource.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.resource.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.resource.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.resource.delete,
      data: opts
    })
  }

  findCategory (opts) {
    return this.httpGet({
      url: urls.resource.findCategory,
      data: opts
    })
  }

  createCategory (opts) {
    return this.httpPost({
      url: urls.resource.createCategory,
      data: opts
    })
  }

  updateCategory (opts) {
    return this.httpPost({
      url: urls.resource.updateCategory,
      data: opts
    })
  }

  deleteCategory (opts) {
    return this.httpPost({
      url: urls.resource.deleteCategory,
      data: opts
    })
  }
}

export default new Resource



// WEBPACK FOOTER //
// ./src/models/resource.js